import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/Dashboard/getDashboardLiveCallDetailsCnt/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed
export const getDashboardLiveCallStatsAPIURL = BaseURl + "Dashboard/getDashboardLiveCallDetailsCnt/v1/";

//https://testcockpit.p2k.in/api/Dashboard/getDashboardSystemCallDetailsCnt/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed
export const getDashboardSystemCallStatsAPIURL = BaseURl + "Dashboard/getDashboardSystemCallDetailsCnt/v1/";

//https://testcockpit.p2k.in/api/Dashboard/getDashboardColdCallDetailsCnt/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed
export const getDashboardColdCallStatsAPIURL = BaseURl + "Dashboard/getDashboardColdCallDetailsCnt/v1/";

//https://testcockpit.p2k.in/api/dashboard/usersCallVerificationStats/v1/?userUUID=bfa9b0ff-49be-11ef-bab4-22f17ecb52c5&isPagination=0&pageNo=0&perPageRec=0
export const getDashboardUserWiseVerificationCallStatsAPIURL = BaseURl + "Dashboard/usersCallVerificationStats/v1/";

//https://testcockpit.p2k.in/api/dashboard/usersLiveColdCallsStats/v1/?userUUID=bfa9b0ff-49be-11ef-bab4-22f17ecb52c5&isPagination=0&pageNo=0&perPageRec=0
export const getDashboardUserWiseLiveOrCloldCallStatsAPIURL = BaseURl + "Dashboard/usersLiveColdCallsStats/v1/";

//https://testcockpit.p2k.in/api/dashboard/usersSystemCallsStats/v1/?userUUID=bfa9b0ff-49be-11ef-bab4-22f17ecb52c5&isPagination=0&pageNo=0&
export const getDashboardUserWiseSysGeneratedCallStatsAPIURL = BaseURl + "Dashboard/usersSystemCallsStats/v1/";


